import React, { useContext, useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import { FileAddOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import { Container } from "components/Container";
import { SecurityContext } from "context/SecurityContextProvider";
import { MisDocumentosContext } from "context/MisDocumentos/MisDocumentosContext";
import { MisDocumentosContextProvider } from "context/MisDocumentos/MisDocumentosContextProvider";
import { PortalColaboradorService } from "services/PortalColaboradorService";
import {
	formularioSeleccionadoAtom,
	visibleVisorFormularioAtom,
	loadingPdfAtom,
} from "pages/mis-documentos/componentes/MisDocumentosWeb/MisDocumentosWebStorage";
import { VisorFormulario } from "pages/mis-documentos/componentes/MisDocumentosWeb/componentes";
import { ModalFirmar } from "pages/mis-documentos/componentes/ModalFirmar";
import { ModalExito } from "pages/mis-documentos/componentes/ModalExito";

function ListaFormatos() {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const { setDocumentoSeleccionado } = useContext(MisDocumentosContext);
	const [, setFormularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);
	const [, setLoadingPdf] = useAtom(loadingPdfAtom);

	const [formatos, setFormatos] = useState([]);
	const [loading, setLoading] = useState(false);
	const [formularioIniciandoId, setFormularioIniciandoId] = useState(undefined);

	useEffect(() => {
		const cargarFormatos = async () => {
			try {
				setLoading(true);
				const respuesta = await PortalColaboradorService.listarFormatos(
					getUsuarioAutenticado().empresaSeleccionada.id
				);
				setFormatos(respuesta);
			} catch (error) {
				console.error(error);
			} finally {
				setLoading(false);
			}
		};
		cargarFormatos();
	}, []);

	const onClickGenerarFormato = async (formulario) => {
		try {
			setFormularioIniciandoId(formulario.id);
			const documento = await PortalColaboradorService.iniciarFormato(formulario.id);
			setDocumentoSeleccionado(documento);
			setFormularioSeleccionado(documento);
			setLoadingPdf(true);
			setVisibleVisorFormulario(true);
		} catch (error) {
			console.error(error);
			message.error("No se pudo generar el formato. Intenta nuevamente.");
		} finally {
			setFormularioIniciandoId(undefined);
		}
	};

	const columnas = [
		{
			title: "Formato",
			dataIndex: "nombre",
			key: "nombre",
		},
		{
			title: "Acciones",
			key: "acciones",
			align: "center",
			render: (texto, fila) => (
				<Button
					type="link"
					loading={formularioIniciandoId === fila.id}
					onClick={() => onClickGenerarFormato(fila)}
				>
					<FileAddOutlined /> Generar Formato
				</Button>
			),
		},
	];

	return <Table rowKey={(formato) => formato.id} dataSource={formatos} columns={columnas} loading={loading} pagination={false} />;
}

function FormatosPage() {
	const [loadingPdf] = useAtom(loadingPdfAtom);

	return (
		<MisDocumentosContextProvider>
			<Container titulo="Formatos">
				<ListaFormatos />
				<VisorFormulario loadingPdf={loadingPdf} />
				<ModalFirmar />
				<ModalExito />
			</Container>
		</MisDocumentosContextProvider>
	);
}

export default FormatosPage;
